// // import React, { useEffect } from "react";
// // import {
// //   Card,
// //   CardContent,
// //   Typography,
// //   Button,
// //   Grid,
// //   Divider,
// //   Box,
// // } from "@mui/material";
// // import UserHeader from "../UserComponent/UserHeader";
// // import payment_icon from "../../images/payment_icon.png";
// // import payCallIcon from "../../images/payCallIcon.png";
// // import payEmailIcon from "../../images/payEmailIcon.png";
// // import { useLocation, useNavigate } from "react-router-dom";

// // export const Success = ({ isModal = false, data, onClose }) => {
// //   // const navigate = useNavigate();
// //   // const location = useLocation();
// //   // const { package: selectedPackage, payment_id } = location.state || {};

// //   const navigate = useNavigate();

// //   // 🔹 Prefer modal data, fallback to route state (SAFE)
// //   const selectedPackage = data?.package;
// //   const payment_id = data?.payment_id;

// //   const email = localStorage.getItem("email");
// //   const currentDateTime = new Date().toLocaleString("en-GB", {
// //     day: "2-digit",
// //     month: "short",
// //     year: "numeric",
// //     hour: "2-digit",
// //     minute: "2-digit",
// //     hour12: true,
// //   });

// //   return (
// //     <Box
// //       sx={{
// //         position: isModal ? "fixed" : "static",
// //         inset: isModal ? 0 : "auto",
// //         backgroundColor: isModal ? "rgba(0,0,0,0.6)" : "transparent",
// //         zIndex: isModal ? 9999 : "auto",
// //         display: "flex",
// //         alignItems: "center",
// //         justifyContent: "center",
// //       }}
// //     >
// //       {!isModal && <UserHeader />}

// //       {/* <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}> */}
// //       <Grid
// //         container
// //         justifyContent="center"
// //         alignItems="center"
// //         style={{ minHeight: isModal ? "auto" : "100vh" }}
// //       >
// //         <Grid item lg={6} md={8} sm={10} xs={12}>
// //           <Card elevation={4} sx={{ p: 4 }}>
// //             <CardContent>
// //               <Box textAlign="center" mb={3}>
// //                 <img
// //                   src={payment_icon}
// //                   alt="Payment Icon"
// //                   style={{ maxWidth: "100px", marginBottom: "20px" }}
// //                 />
// //                 <Typography variant="h4" gutterBottom className="orderTitlet">
// //                   Order Placed Successfully!
// //                 </Typography>
// //                 <Typography
// //                   variant="subtitle1"
// //                   color="textSecondary"
// //                   className="paymentID"
// //                 >
// //                   Payment ID: {payment_id}, {currentDateTime}
// //                 </Typography>
// //               </Box>

// //               <Divider sx={{ my: 3 }} />

// //               <Box
// //                 display="flex"
// //                 justifyContent="space-between"
// //                 alignItems="center"
// //                 mb={2}
// //               >
// //                 <Typography variant="h5" className="planTxt">
// //                   {selectedPackage.package_name} Plan for{" "}
// //                   {selectedPackage.valid_period} Months
// //                 </Typography>
// //                 <Typography variant="h5" className="planTxt">
// //                   ₹ {selectedPackage.package_price}
// //                 </Typography>
// //               </Box>
// //               {/* <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
// //                                     <Typography variant="h6"  className="planTxtYellow">GST 12%</Typography>
// //                                     <Typography variant="h6" className="planTxtYellow">₹ 360</Typography>
// //                                 </Box> */}
// //               <Box
// //                 display="flex"
// //                 justifyContent="space-between"
// //                 alignItems="center"
// //               >
// //                 <Typography variant="h6" className="planTxtYellow">
// //                   Total Price
// //                 </Typography>
// //                 <Typography variant="h6" className="planTxtYellow">
// //                   ₹ {selectedPackage.package_price}
// //                 </Typography>
// //               </Box>

// //               <Divider sx={{ my: 3 }} />
// //               <div className="mt-3">
// //                 <Typography
// //                   variant="body1"
// //                   textAlign="center"
// //                   mb={2}
// //                   className="packTxt"
// //                 >
// //                   Your packages will be activated shortly.
// //                 </Typography>
// //                 <Typography
// //                   variant="body2"
// //                   color="textSecondary"
// //                   textAlign="center"
// //                   className="payMesg mt-2"
// //                 >
// //                   We will send an invoice with your order details within 24
// //                   hours to your registered email:
// //                 </Typography>
// //                 <Typography
// //                   variant="body2"
// //                   textAlign="center"
// //                   sx={{ fontWeight: "bold", mt: 1 }}
// //                 >
// //                   {email}
// //                 </Typography>
// //               </div>

// //               <Divider sx={{ my: 3 }} />

// //               <Typography
// //                 variant="h6"
// //                 textAlign="center"
// //                 className="queriesTxt"
// //               >
// //                 For any further queries
// //               </Typography>
// //               <Box display="flex" justifyContent="center" gap={3} mt={1}>
// //                 <Typography variant="body1">
// //                   <img
// //                     src={payCallIcon}
// //                     alt="Phone Icon"
// //                     style={{ verticalAlign: "middle", marginRight: "8px" }}
// //                   />
// //                   +918600555740
// //                 </Typography>
// //                 <Typography variant="body1">
// //                   <img
// //                     src={payEmailIcon}
// //                     alt="Email Icon"
// //                     style={{ verticalAlign: "middle", marginRight: "8px" }}
// //                   />
// //                   support@indmatrimony.in
// //                 </Typography>
// //               </Box>

// //               <Box textAlign="center" mt={4}>
// //                 {/* <Button variant="contained" color="primary" 
// //                                     // href="/" 
// //                                     onClick={() => navigate("/", { replace: true })}
// //                                     size="large">
// //                                         Go To My Dashboard
// //                                     </Button> */}

// //                 <Button
// //                   variant="contained"
// //                   color="primary"
// //                   onClick={() => {
// //                     if (isModal && onClose) {
// //                       onClose(); // 👈 closes modal, Upgrade stays mounted
// //                     } else {
// //                       navigate("/my_matches", { replace: true });
// //                     }
// //                   }}
// //                   size="large"
// //                 >
// //                   Go To My Dashboard
// //                 </Button>
// //               </Box>
// //             </CardContent>
// //           </Card>
// //         </Grid>
// //       </Grid>
// //     </Box>
// //   );
// // };












import React, { useEffect } from "react";

import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Lottie from "lottie-react";
import { useNavigate } from "react-router-dom";

import successBgAnimation from "../../images/congratulationsAnimation.json";
import greenCheckAnimation from "../../images/greenCheck.json";
import payCallIcon from "../../images/payCallIcon.png";
import payEmailIcon from "../../images/payEmailIcon.png";

export const Success = ({ isModal = false, data, onClose, onSuccessOpen, }) => {
  const navigate = useNavigate();

  const selectedPackage = data?.package;

  useEffect(() => {
  if (onSuccessOpen) {
    onSuccessOpen();
  }
}, []);


      const montserratTypography = {
  "& .MuiTypography-root": {
    fontFamily: "'Montserrat', sans-serif",
  },
};



  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...montserratTypography,
      }}
    >
      {/* 🎉 Background Lottie */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
        }}
      >
        <Lottie
          animationData={successBgAnimation}
          loop={false}
          style={{ width: "100%", height: "100%" }}
        />
      </Box>

      {/* Modal Container */}
      <Box
        sx={{
          position: "relative",
        //   width: modalWidth,

          width: {
      xs: "95%",   // 0–600px
      sm: "85%",   // 600–768px
      md: "55%",   // 768–1024px
      lg: "40%",   // 1024–1400px
      xl: "35%",   // 1400px+
    },



          backgroundColor: "#fff",
          borderRadius: "22px",
          padding: "32px 24px",
          textAlign: "center",
          boxShadow: "0px 20px 40px rgba(0,0,0,0.2)",
          overflow: "hidden",

          // 🔥 FONT FIX
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        {/* 🟢 Top Gradient Curve (same as Failed) */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "190px",
            background:
              "linear-gradient(180deg, #bbf1dc 0%, #FFF 75%)",
            borderBottomLeftRadius: "100% 45%",
            borderBottomRightRadius: "100% 45%",
            zIndex: 0,
          }}
        />

        {/* Foreground Content */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          {/* Close */}
          {isModal && (
            <IconButton
              onClick={onClose}
              sx={{ position: "absolute", top: 0, right: 0 }}
            >
              <CloseIcon />
            </IconButton>
          )}

          {/* ✅ Success Animation */}
          <Box sx={{ width: 90, mx: "auto", mb: 1 }}>
            <Lottie animationData={greenCheckAnimation} loop={true} />
          </Box>

          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 700,
              color: "#1BA672",
              mb: 2,
              fontFamily: 'Montserrat',
            }}
          >
            Payment Completed Successfully
          </Typography>

          {/* Plan Card */}
          <Box
            sx={{
              backgroundColor: "#F9FAFB",
              borderRadius: "14px",
              padding: "14px 16px",
              mb: 2,
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                color: "#888",
                mb: 0.5,
                textAlign: "left",
                fontWeight: 500,
              }}
            >
              SELECTED PLAN
            </Typography>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography sx={{ fontWeight: 600 }}>
                {selectedPackage?.package_name} Plan for{" "}
                {selectedPackage?.valid_period} Months
              </Typography>

              <Typography sx={{ fontWeight: 700 }}>
                ₹ {selectedPackage?.package_price}
              </Typography>
            </Box>

            <Divider sx={{ my: 1.2, borderColor: "#00000030" }} />

            <Box display="flex" justifyContent="space-between">
              <Typography sx={{ color: "#555" }}>
                Total Amount Paid
              </Typography>
              <Typography sx={{ fontWeight: 700, color: "#2563EB" }}>
                ₹ {selectedPackage?.package_price}
              </Typography>
            </Box>
          </Box>

          <Typography sx={{ color: "#16A34A", fontWeight: 500, mb: 0.5 }}>
            Your package will be activated shortly
          </Typography>

          <Typography sx={{ fontSize: 13, color: "#777", mb: 2 }}>
            A tax invoice has been sent to your registered email address.
          </Typography>

          <Divider sx={{ my: 2, borderColor: "#00000030" }} />

          <Typography sx={{ fontSize: 14, mb: 1 }}>
            Need help? Talk to our support team.
          </Typography>

          <Box
            display="flex"
            justifyContent="center"
            gap={3}
            sx={{ fontSize: 14 }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <img src={payCallIcon} alt="call" width={18} />
              +91 8600555740
            </Box>

            <Box display="flex" alignItems="center" gap={1}>
              <img src={payEmailIcon} alt="email" width={18} />
              support@indmatrimony.in
            </Box>
          </Box>

          <Button
            fullWidth
            sx={{
              mt: 3,
              height: 48,
              borderRadius: "999px",
              fontWeight: 600,
              fontFamily: "'Montserrat', sans-serif",
              background:
                "linear-gradient(90deg, #FF8A00 0%, #FF5C8A 100%)",
            }}
            variant="contained"
            onClick={() => {
              if (isModal && onClose) onClose();
              else navigate("/my_matches", { replace: true });
            }}
          >
            Go to My Dashboard →
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
